import { Link } from "react-router-dom";
import { SocialIcons } from "@/components/Social";

const legalLinks = [
  { to: "/equipo", label: "Equipo" },
  { to: "/organigrama", label: "Organigrama" },
  { to: "/instalar", label: "Instalar app" },
  { to: "/aviso-legal", label: "Aviso legal" },
  { to: "/privacidad", label: "Privacidad" },
  { to: "/cookies", label: "Cookies" },
  { to: "/terminos", label: "Términos" },
  { to: "/accesibilidad", label: "Accesibilidad" },
];

export const Footer = () => (
  <footer className="relative z-10 border-t border-white/10 px-5 py-16 md:px-10" data-testid="footer">
    <div className="mx-auto max-w-7xl">
      <div className="flex flex-col justify-between gap-10 md:flex-row md:items-end">
        <div>
          <a href="#top" className="inline-block" data-testid="footer-logo">
            <img
              src="/cyvr-logo-full.png"
              alt="CYVR LABS — Ciberseguridad · Defending Tomorrow · cyvrlabs.com"
              className="h-24 w-auto object-contain drop-shadow-[0_0_18px_rgba(0,240,255,0.25)] md:h-28"
            />
          </a>
        </div>

        <SocialIcons />
      </div>

      <nav
        className="mt-12 flex flex-wrap gap-x-6 gap-y-3 font-mono-tech text-[11px] uppercase tracking-[0.15em] text-white/50"
        data-testid="footer-legal-nav"
        aria-label="Enlaces legales"
      >
        {legalLinks.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            data-testid={`footer-legal-${l.to.replace("/", "")}`}
            className="transition-colors duration-200 hover:text-cyber-cyan"
          >
            {l.label}
          </Link>
        ))}
        <button
          type="button"
          data-testid="footer-configure-cookies"
          onClick={() => window.dispatchEvent(new Event("cyvr:open-cookie-settings"))}
          className="uppercase tracking-[0.15em] transition-colors duration-200 hover:text-cyber-cyan"
        >
          Configurar cookies
        </button>
      </nav>

      <div className="mt-10 flex flex-col justify-between gap-4 border-t border-white/10 pt-8 font-mono-tech text-[11px] uppercase tracking-[0.15em] text-white/40 md:flex-row">
        <span>© {new Date().getFullYear()} CYVR Labs</span>
        <span>Elite Cyber Defense · The Future Guardian</span>
      </div>
    </div>
  </footer>
);
